/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => new App.StripeHelper().init());


App.StripeHelper = class StripeHelper {

  constructor() {
    this.init = this.init.bind(this);
    this.on_submit = this.on_submit.bind(this);
    this.stripeResponseHandler = this.stripeResponseHandler.bind(this);
  }

  init() {
    this.card_form        = $(".js-credit-card-form");
    this.card_form_button = $(".js-credit-card-form-submit");
    this.public_key       = $(".js-credit-card-form-public-key").attr("value");

    return this.card_form
      .off("submit", this.on_submit)
      .on("submit", this.on_submit);
  }


  on_submit(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    // Only try Stripe if the form is valid
    if ((this.card_form.find(":invalid").length === 0) && !this.card_form_button.prop("disabled")) {
      // disable the submit button to prevent repeated clicks
      this.card_form_button.prop("disabled", true);

      Stripe.setPublishableKey(this.public_key);
      // does idempotency_key work here??
      Stripe.card.createToken(this.card_form, this.stripeResponseHandler, { idempotency_key: Date.now() });
    }

    // prevent the form from submitting with the default action
    return false;
  }


  stripeResponseHandler(status, response) {
    if (response.error) {
      this.card_form_button.prop("disabled", false);
      return this.card_form.find('.js-payment-errors').text(response.error.message);

    } else {
      // token contains id, last4, and card type
      const token = response["id"];

      // insert the token into the form so it gets submitted to our server
      this.card_form.append("<input type='hidden' name='token' value='" + token + "'/>");

      // and submit via rails remote
      return this.card_form.trigger("submit.rails");
    }
  }
};
